import { render } from "./EmailConfirm.vue?vue&type=template&id=144bbc42&scoped=true"
import script from "./EmailConfirm.vue?vue&type=script&lang=js"
export * from "./EmailConfirm.vue?vue&type=script&lang=js"

import "./EmailConfirm.vue?vue&type=style&index=0&id=144bbc42&lang=stylus&scoped=true"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144bbc42"]])

export default __exports__